import type React from "react"

import { Box, Paper, useTheme } from "@mui/material"

interface StackedBarGraphTooltipProps {
  children: React.ReactNode
}

export const StackedBarGraphTooltip: React.FC<StackedBarGraphTooltipProps> = ({
  children,
}) => {
  const theme = useTheme()

  return (
    <Paper
      elevation={5}
      sx={{
        minWidth: theme.typography.pxToRem(180),
        p: 1.5,
        transition: "opacity 0.45s",
      }}
    >
      {/* Subtle border around the tooltip */}
      <Box
        sx={{
          border: `1px solid ${theme.palette.action.focus}`,
          borderRadius: "9px",
          position: "absolute",
          top: -1,
          left: -1,
          right: -1,
          bottom: -1,
        }}
      />
      {children}
    </Paper>
  )
}
